// 複刻文化 Fuko — 主導覽
// 僅包含公開頁面入口

export interface NavItem {
  label: string;
  href: string;
  children?: { label: string; href: string }[];
}

export const mainNavigation: NavItem[] = [
  { label: '首頁', href: '/' },
  { label: '品牌介紹', href: '/about' },
  { label: '書籍', href: '/books' },
  { label: '合作購書通路', href: '/stores' },
  { label: '常見問題', href: '/faq' },
  { label: '閱讀推薦', href: '/blog' },
];
